<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="row mt-5 mb-5">
        <div class="col-md-6 title">
          <h1>Page not found</h1>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>I'm sorry, it looks like you found an unknown page. Get back in the app <a href="/">here</a>.</p>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>


<style lang="scss" scoped>
    .title {
        @media (max-width: 767px) {
            text-align: center;
            margin-bottom: 2em;
        }
    }
</style>


<script>
    import Footer from "../navigation/Footer"
    import NavBar from "../navigation/Navbar"

    export default {
        name: 'Notfound',
        components: {Footer, NavBar}
    }
</script>
